/** Unique <title> and meta description per public marketing route (Google SERP). */
export const PAGE_SEO: Record<string, { title: string; description: string }> = {
  "/": {
    title: "Duri Ridesharing App | Intercity, Intracity & Daily Commute Carpool",
    description:
      "Trusted ridesharing app for intercity travel, intracity trips, and daily commute carpool. Find rides, offer seats, and travel with verified riders and hosts.",
  },
  "/how-duri-works": {
    title: "How Duri Works | Safe Ridesharing & Carpool Booking",
    description:
      "Learn how Duri helps riders and hosts share rides safely. Find rides, offer seats, verify profiles, chat securely, and travel with confidence.",
  },
  "/available-rides": {
    title: "Available Rides | Intercity & Intracity Carpool on Duri",
    description:
      "Search available rides for city-to-city travel, local trips, and daily commute carpool. Book verified rides on Duri across popular routes in India.",
  },
  "/verificationprocess": {
    title: "Duri Verification Process | How We Verify Riders & Hosts",
    description:
      "Learn how Duri verifies guest and host profiles with ID checks, vehicle details, and safety standards before your first carpool booking.",
  },
  "/offer-a-ride": {
    title: "Offer a Ride in India | Share Seats & Save Travel Cost with Duri",
    description:
      "Offer your empty seats for intercity or daily commute travel. Share ride costs, connect with verified co-travelers, and make every trip more economical.",
  },
  "/ride-requests": {
    title: "Ride Requests | Passengers Looking for Rides",
    description:
      "Browse ride requests from passengers looking for intercity, city, or daily commute travel. Match your route and offer seats safely on Duri.",
  },
  "/daily-commute-carpool": {
    title: "Daily Commute Carpool | Share Office or Business Travel with Duri",
    description:
      "Join daily commute carpool for office or business routes and regular travel in cities. Save fuel, reduce traffic, and travel with verified commuters on Duri.",
  },
  "/CorporateCarpool": {
    title: "Free Corporate Carpool Program for Companies | Duri Ridesharing",
    description:
      "Launch a free corporate carpool & employee commute program with Duri. Cut fuel costs, ease parking, reduce CO₂ and power your CSR & ESG goals — guests save ~₹7,920/month, hosts gain ~₹13,200/month.",
  },
  "/hyderabad-daily-commute-carpool": {
    title: "Hyderabad Daily Commute Carpool | Hitech City & Gachibowli Office Rides",
    description:
      "Share daily office commutes in Hyderabad — Hitech City, Gachibowli, Financial District, and ORR tech parks. Save fuel and tolls with verified co-travellers on Duri.",
  },
  "/hyderabad-carpool": {
    title: "Hyderabad Carpool | Daily Commute & Intercity Rides on Duri",
    description:
      "Hyderabad carpool hub for office commutes and intercity routes to Vijayawada and Guntur. Find verified hosts in Hitech City, Gachibowli, and beyond.",
  },
  "/vijayawada-ridesharing": {
    title: "Vijayawada Ridesharing | Local & Intercity Carpools on Duri",
    description:
      "Vijayawada ridesharing for daily travel and intercity trips to Hyderabad. Pickup zones at Benz Circle, PVP Mall, and Kanaka Durga — verified hosts on Duri.",
  },
  "/guides/how-carpooling-works-india": {
    title: "How Carpooling Works in India | Duri Guide",
    description:
      "Learn how carpooling works in India — guests, hosts, cost-splitting, city commutes vs intercity highways, and booking safely on Duri.",
  },
  "/guides/ridesharing-legal-safe-india": {
    title: "Is Ridesharing Legal & Safe in India? | Duri Guide",
    description:
      "How non-commercial ride sharing differs from taxis in India, what the law generally allows, and how Duri keeps carpools safe with verification.",
  },
  "/guides/save-commute-cost-hyderabad": {
    title: "How to Save Daily Commute Cost in Hyderabad | Duri Guide",
    description:
      "Practical tips for Hyderabad office commuters to cut fuel, ORR toll, and parking costs with daily carpool on Hitech City and Gachibowli routes.",
  },
  "/guides/intercity-ridesharing-vs-cab-bus": {
    title: "Intercity Ridesharing vs Cab or Bus | Duri Guide",
    description:
      "Compare intercity carpool cost, comfort, and timing against private cabs and AC buses on busy Indian highway corridors.",
  },
  "/safety": {
    title: "Duri Safety | Verified Riders, Hosts, Tracking & Secure Rides",
    description:
      "See how Duri keeps ridesharing safe with profile verification, real-time tracking, secure communication, and trusted rider-host matching.",
  },
  "/popular-routes": {
    title: "Popular Rides in India | Duri Ridesharing",
    description:
      "Browse popular intercity rides on Duri — Hyderabad to Vijayawada, Bengaluru to Chittoor, and more. Find verified rides or offer seats.",
  },
  "/about-duri": {
    title: "About Duri | India's Trusted Ridesharing & Carpool App",
    description:
      "Learn about Duri — building safe, affordable ridesharing for intercity travel and daily commute across India.",
  },
  "/news": {
    title: "Mohan Nanduri Keynote at KR Bharat Conclave 2026 | Duri News",
    description:
      "Watch Mohan Nanduri's keynote address at KR Bharat Conclave 2026 on redefining Indian mobility, live Vahan & DigiLocker trust, and sustainable carpooling under Vikasit Bharat 2047.",
  },
  "/ridesharing-benefits": {
    title: "Ridesharing Benefits | Save Money, Time & Emissions with Duri",
    description:
      "Discover the benefits of ridesharing and carpool — lower travel costs, reduced traffic, fewer emissions, and verified co-travellers.",
  },
  "/ridesharing-impact": {
    title: "Ridesharing Impact | Environmental & Social Benefits of Duri",
    description:
      "See how Duri ridesharing reduces CO₂ emissions, eases congestion, and makes travel more affordable across India.",
  },
  "/help-center": {
    title: "Duri Help Center | Support, Contact & Ride Assistance",
    description:
      "Get help with Duri ridesharing — contact support via WhatsApp or email, report issues, and find answers to common questions.",
  },
  "/faqs": {
    title: "Duri FAQs | Ridesharing, Carpool & Daily Commute Questions",
    description:
      "Frequently asked questions about Duri ridesharing — booking rides, offering seats, safety, payments, and daily commute carpool.",
  },
  "/intercity-ridesharing-india": {
    title: "Intercity Ridesharing in India | Carpool Routes & City Hubs on Duri",
    description:
      "Explore intercity carpool routes across India on Duri — Hyderabad, Vijayawada, Bangalore, Chennai corridors with verified hosts and per-seat pricing.",
  },
  "/bangalore-carpool": {
    title: "Bangalore Carpool | Daily Commute & Hyderabad Route on Duri",
    description:
      "Bangalore carpool for Whitefield, Electronic City office commutes and Hyderabad NH44 intercity rides. Verified hosts on Duri.",
  },
  "/chennai-ridesharing": {
    title: "Chennai Ridesharing | OMR Commute, Tirupati & Nellore Routes",
    description:
      "Chennai ridesharing for daily OMR commutes, Tirupati pilgrimage weekends, and Nellore NH16 pools on Duri.",
  },
  "/vijayawada-daily-commute-carpool": {
    title: "Vijayawada Daily Commute Carpool | Office & Guntur Belt on Duri",
    description:
      "Share daily commutes in Vijayawada — Benz Circle, Auto Nagar, and Guntur belt routes with verified co-travellers on Duri.",
  },
};
